export default [
  {
    title: 'breadcrumb.jackpotSetting',
    route: 'jackpot-setting',
    icon: '',
    resource: 'jackpot-setting',
    action: 'read'
  }
];